// extracted by mini-css-extract-plugin
export default {"button":"TD3u+"};